import * as React from 'react';
import type { IconProps } from '../icon-prop-types';

const TESTID = 'app-store-inverted-svg';
export const AppStoreInvertedIcon = ({ width = 140, height = 42 }: IconProps) => {
    return (
        <svg
            data-testid={TESTID}
            width={width}
            height={height}
            viewBox="0 0 148 44"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
        >
            <title>App Badges / iOS - White</title>
            <path fill="white" d="M6,0h136c3.3,0,6,2.7,6,6v32c0,3.3-2.7,6-6,6H6c-3.3,0-6-2.7-6-6V6C0,2.7,2.7,0,6,0z" />
            <path
                fill="black"
                d="M56.7,33.9h2.5l-5.4-15.1h-2.5l-5.4,15.1h2.4l1.4-4h5.7L56.7,33.9z M52.4,21.5h0.2l2.2,6.4
			h-4.5L52.4,21.5z M65.8,22.3c-1.5,0-2.9,0.8-3.6,2.1H62v-1.9h-2.2v15.1h2.2v-5.4h0.2c0.6,1.2,1.9,1.9,3.5,1.9
			c2.9,0,4.7-2.3,4.7-5.9S68.7,22.3,65.8,22.3z M65.1,32c-1.9,0-3.1-1.5-3.1-3.9c0-2.4,1.2-3.9,3.1-3.9c1.9,0,3,1.5,3,3.9
			C68.2,30.6,67,32,65.1,32z M77.4,22.3c-1.5,0-2.9,0.8-3.6,2.1h-0.2v-1.9h-2.2v15.1h2.2v-5.4h0.2c0.6,1.2,1.9,1.9,3.5,1.9
			c2.9,0,4.7-2.3,4.7-5.9S80.3,22.3,77.4,22.3z M76.8,32c-1.9,0-3.1-1.5-3.1-3.9c0-2.4,1.2-3.9,3.1-3.9c1.9,0,3,1.5,3,3.9
			C79.8,30.6,78.7,32,76.8,32z M86.9,29.8c0.2,2.7,2.4,4.4,5.7,4.4c3.6,0,5.8-1.8,5.8-4.7c0-2.3-1.3-3.5-4.4-4.3l-1.7-0.4
			c-2-0.5-2.8-1.1-2.8-2.2c0-1.4,1.2-2.3,3.1-2.3c1.8,0,3,0.9,3.2,2.3h2.3c-0.1-2.6-2.4-4.3-5.4-4.3c-3.3,0-5.5,1.8-5.5,4.5
			c0,2.2,1.2,3.5,4,4.2l1.9,0.5c2,0.5,2.9,1.2,2.9,2.3c0,1.3-1.4,2.3-3.3,2.3c-2,0-3.4-0.9-3.6-2.4H86.9z M100.3,19.7v2.8h-1.9v1.9
			h1.9v6.5c0,2.2,1,3.1,3.5,3.1c0.4,0,0.8-0.1,1.2-0.1V32c-0.3,0-0.5,0.1-0.8,0.1c-1.1,0-1.6-0.5-1.6-1.7v-5.9h2.5v-1.9h-2.5v-2.8
			H100.3z M110.7,32.1c-2,0-3-1.4-3-3.9c0-2.5,1.1-3.9,3-3.9c1.9,0,3,1.4,3,3.9C113.7,30.6,112.6,32.1,110.7,32.1z M110.7,34.1
			c3.3,0,5.4-2.2,5.4-5.9c0-3.7-2-5.9-5.4-5.9c-3.3,0-5.4,2.2-5.4,5.9C105.3,31.9,107.4,34.1,110.7,34.1z M117.1,33.9h2.2v-6.8
			c0-1.6,1.2-2.7,2.9-2.7c0.4,0,1.1,0.1,1.2,0.1v-2.2c-0.2-0.1-0.7-0.1-1-0.1c-1.5,0-2.7,0.8-3.1,1.9h-0.2v-1.8h-2.2V33.9z
			 M128.5,24.2c1.7,0,2.7,1.2,2.8,3h-5.7C125.7,25.3,126.8,24.2,128.5,24.2z M131.3,30.8c-0.4,0.9-1.3,1.4-2.7,1.4
			c-1.8,0-3-1.3-3-3.3v-0.1h8V28c0-3.6-1.9-5.8-5.1-5.8c-3.2,0-5.2,2.3-5.2,6c0,3.7,2,5.9,5.2,5.9c2.6,0,4.4-1.3,4.9-3.3H131.3
			L131.3,30.8z"
            />
            <path
                fill="black"
                d="M47.9,6.9v7.2h2.6c2.1,0,3.4-1.3,3.4-3.6c0-2.3-1.2-3.6-3.4-3.6H47.9z M49,7.9h1.4
			c1.5,0,2.4,0.9,2.4,2.6c0,1.7-0.9,2.6-2.4,2.6H49V7.9z M57.8,13.3c-0.9,0-1.5-0.7-1.5-1.9c0-1.2,0.5-1.9,1.5-1.9
			c0.9,0,1.5,0.7,1.5,1.9C59.2,12.6,58.7,13.3,57.8,13.3z M57.8,14.2c1.6,0,2.5-1.1,2.5-2.8c0-1.8-1-2.8-2.5-2.8
			c-1.6,0-2.6,1.1-2.6,2.8C55.2,13.2,56.2,14.2,57.8,14.2z M68.7,8.7h-1.1l-1,4.2h-0.1l-1.1-4.2h-1l-1.1,4.2h-0.1l-1-4.2h-1.1
			l1.5,5.4h1.1l1.1-4H65l1.1,4h1.1L68.7,8.7z M70.1,14.1h1.1v-3.2c0-0.8,0.5-1.4,1.4-1.4c0.8,0,1.2,0.4,1.2,1.3v3.3h1.1v-3.5
			c0-1.3-0.7-2-1.9-2c-0.8,0-1.4,0.4-1.7,1h-0.1V8.7h-1V14.1z M76.6,14.1h1.1V6.6h-1.1V14.1z M81.8,13.3c-0.9,0-1.5-0.7-1.5-1.9
			c0-1.2,0.5-1.9,1.5-1.9c0.9,0,1.5,0.7,1.5,1.9C83.2,12.6,82.7,13.3,81.8,13.3z M81.8,14.2c1.6,0,2.5-1.1,2.5-2.8
			c0-1.8-1-2.8-2.5-2.8c-1.6,0-2.6,1.1-2.6,2.8C79.2,13.2,80.2,14.2,81.8,14.2z M87.6,13.3c-0.6,0-1-0.3-1-0.8
			c0-0.5,0.3-0.7,1.1-0.8l1.3-0.1v0.5C89,12.8,88.4,13.3,87.6,13.3z M87.3,14.2c0.7,0,1.3-0.3,1.6-0.9h0.1v0.8h1v-3.7
			c0-1.1-0.8-1.8-2.1-1.8c-1.2,0-2.1,0.6-2.2,1.5h1c0.1-0.4,0.5-0.6,1.1-0.6c0.7,0,1.1,0.3,1.1,0.9v0.5L87.6,11
			c-1.3,0.1-2,0.6-2,1.6C85.5,13.6,86.3,14.2,87.3,14.2z M93.8,14.2c0.7,0,1.4-0.4,1.7-0.9h0.1v0.9h1V6.6h-1.1v3h-0.1
			c-0.3-0.6-0.9-1-1.7-1c-1.4,0-2.2,1.1-2.2,2.8C91.6,13.1,92.5,14.2,93.8,14.2z M94.1,9.6c0.9,0,1.5,0.7,1.5,1.8
			c0,1.1-0.6,1.8-1.5,1.8c-0.9,0-1.4-0.7-1.4-1.9C92.7,10.3,93.2,9.6,94.1,9.6z M103.8,13.3c-0.9,0-1.5-0.7-1.5-1.9
			c0-1.2,0.5-1.9,1.5-1.9c0.9,0,1.5,0.7,1.5,1.9C105.3,12.6,104.7,13.3,103.8,13.3z M103.8,14.2c1.6,0,2.5-1.1,2.5-2.8
			c0-1.8-1-2.8-2.5-2.8c-1.6,0-2.6,1.1-2.6,2.8C101.3,13.2,102.2,14.2,103.8,14.2z M107.9,14.1h1.1v-3.2c0-0.8,0.5-1.4,1.4-1.4
			c0.8,0,1.2,0.4,1.2,1.3v3.3h1.1v-3.5c0-1.3-0.7-2-1.9-2c-0.8,0-1.4,0.4-1.7,1h-0.1V8.7h-1V14.1z M117.8,7.4v1.3h-0.9v0.9h0.9v3.1
			c0,1,0.5,1.5,1.7,1.5c0.2,0,0.4,0,0.6-0.1v-0.9c-0.1,0-0.2,0-0.4,0c-0.5,0-0.8-0.2-0.8-0.8V9.6h1.2V8.7h-1.2V7.4H117.8z
			 M121.6,14.1h1.1v-3.2c0-0.8,0.5-1.4,1.4-1.4c0.8,0,1.2,0.4,1.2,1.3v3.2h1.1v-3.5c0-1.3-0.7-2-1.9-2c-0.8,0-1.4,0.4-1.7,1h-0.1v-3
			h-1.1V14.1z M130.3,9.5c0.8,0,1.3,0.6,1.3,1.4h-2.7C129,10.1,129.5,9.5,130.3,9.5z M131.6,12.7c-0.2,0.4-0.6,0.7-1.3,0.7
			c-0.9,0-1.4-0.6-1.4-1.6v-0.1h3.8v-0.4c0-1.7-0.9-2.7-2.4-2.7c-1.5,0-2.5,1.1-2.5,2.8s0.9,2.8,2.5,2.8c1.2,0,2.1-0.6,2.3-1.6
			H131.6L131.6,12.7z"
            />
            <path
                fill="black"
                d="M32.9,22.3c0,4.4,3.8,5.8,3.9,5.9c0,0.1-0.6,2.1-2,4.1c-1.2,1.8-2.4,3.5-4.4,3.6
			c-1.9,0-2.6-1.1-4.7-1.1c-2.2,0-2.9,1.1-4.7,1.2c-1.9,0.1-3.3-1.9-4.5-3.7C13.9,28.6,12,22,14.5,17.6c1.2-2.2,3.5-3.6,5.9-3.6
			c1.9,0,3.6,1.3,4.8,1.3c1.1,0,3.3-1.6,5.5-1.3c0.9,0,3.6,0.4,5.3,2.9C35.9,16.8,32.9,18.6,32.9,22.3z M29.3,11.5
			c-1,1.2-2.7,2.2-4.3,2c-0.2-1.7,0.6-3.4,1.5-4.5c1-1.2,2.8-2.1,4.2-2.2C30.9,8.6,30.3,10.3,29.3,11.5L29.3,11.5z"
            />
        </svg>
    );
};
AppStoreInvertedIcon.TEST_ID = TESTID;
